import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { 
  LayoutDashboard, Package, ShoppingBag, TrendingUp, Wallet, Star, 
  Settings, Bell, HelpCircle, LogOut, Store, RefreshCcw 
} from 'lucide-react';

const SellerSidebar = ({ collapsed, mobileOpen, onToggle }) => {
  const sidebarClass = `seller-sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`;

  return (
    <aside className={sidebarClass}>
      <Link to="/seller/dashboard" className="seller-logo py-4">
        <div className="seller-logo-icon" style={{ background: 'var(--seller-accent)' }}>
          <Store size={20} className="text-white" />
        </div>
        <span className="seller-logo-text ms-2">Paudhawala</span>
      </Link>

      <nav className="seller-nav custom-scrollbar mt-2">
        <div className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.7rem', padding: '0 1rem', marginBottom: '0.5rem', letterSpacing: '0.5px' }}>
          Seller Panel
        </div>
        
        <NavLink to="/seller/dashboard" end className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <LayoutDashboard size={18} />
          <span>Dashboard</span>
        </NavLink>
        
        <NavLink to="/seller/products" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <Package size={18} />
          <span>Products</span>
        </NavLink>
        
        <NavLink to="/seller/orders" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <ShoppingBag size={18} />
          <span>Orders</span>
        </NavLink>
        
        <NavLink to="/seller/earnings" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <TrendingUp size={18} />
          <span>Earnings</span>
        </NavLink>

        <NavLink to="/seller/wallet" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <Wallet size={18} />
          <span>Wallet / Payouts</span>
        </NavLink>
        
        <NavLink to="/seller/reviews" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <Star size={18} />
          <span>Reviews</span>
        </NavLink>

        <NavLink to="/seller/settings" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <Settings size={18} />
          <span>Profile / Settings</span>
        </NavLink>
        
        <NavLink to="/seller/notifications" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <Bell size={18} />
          <span>Notifications</span>
        </NavLink>

        <NavLink to="/seller/support" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <HelpCircle size={18} />
          <span>Support / Help</span>
        </NavLink>

        <NavLink to="/seller/returns" className={({ isActive }) => `seller-link ${isActive ? 'active' : ''}`}>
          <RefreshCcw size={18} />
          <span>Exchange Requests</span>
        </NavLink>

        <div className="mt-auto pt-3 border-top w-100">
          <button className="seller-link w-100 bg-transparent border-0 text-start text-danger">
            <LogOut size={18} />
            <span className="text-danger fw-bold">Logout</span>
          </button>
        </div>
      </nav>
    </aside>
  );
};

export default SellerSidebar;
